import { render } from "./BusinessSettings.vue?vue&type=template&id=2b3baf26"
import script from "./BusinessSettings.vue?vue&type=script&lang=js"
export * from "./BusinessSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__